import { clinicasApi } from '../../../api';
import { login, logout, checking } from './authSlice';
import { successNotification, dangerNotification } from '../ui';
import { clearNotifications } from '../ui/uiSlice';
import { clearService } from '../service/serviceSlice';
import { encrypt } from '../../../helpers/encryptionHelper';

export const startLogin = (membresia, password) => {
    return async(dispatch) => {

        dispatch(checking());

        try {

            const resp = await clinicasApi.post('/session', {
                login: membresia,
                password: encrypt(password)
            });

            if (resp.status) {

                localStorage.setItem('token', resp.data.accessToken);

                dispatch(login(resp.data));
                dispatch(clearNotifications());
                dispatch(successNotification('Usuario autenticado'));

            } else {

                dispatch(logout(resp));
                dispatch(clearService());
                dispatch(dangerNotification(resp.msg));

            }

        } catch (error) {

            if (typeof error.response !== 'undefined' && typeof error.response.resp !== 'undefined' && typeof error.response.resp.msg !== 'undefined') {

                dispatch(logout(error.response.resp));
                dispatch(clearService());
                dispatch(dangerNotification(error.response.resp.msg));

            } else {

                dispatch(logout({ msg: 'Error al procesar la petición, intenta nuevamente.' }));
                dispatch(clearService());
                dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

            }

        }

    }
}

export const startAutoLogin = () => {
    return async(dispatch) => {

        const token = localStorage.getItem('token');
        if (!token) return dispatch(logout());

        try {

            const resp = await clinicasApi.post('/autoLogin');

            if (resp.status) {

                localStorage.setItem('token', resp.data.accessToken);
                dispatch(login(resp.data));

            } else {

                localStorage.removeItem('token');
                dispatch(logout());

            }

        } catch (error) {

            localStorage.removeItem('token');
            dispatch(logout());

        }

    }
}

export const startLogout = () => {
    return async(dispatch) => {

        localStorage.removeItem('token');
        dispatch(logout());
        dispatch(clearService());
        dispatch(clearNotifications());
        dispatch(successNotification('Sesión terminada'));

    }
}